import ChangeRequest from './ChangeRequest.container';

export default ChangeRequest;